import React, { useState, useRef } from "react";
import DashboardMUI from "../dashboard/DashboardMui";
import providerIcon from "../../images/doctor.svg";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Button from "@material-ui/core/Button";
import SignatureCanvas from "react-signature-canvas";
import ClearIcon from "@material-ui/icons/Clear";
import Axios from "axios";
import userLocalState from "../hooks/useUserState";
import swal from "sweetalert";
import LoadingSpin from "../utils/Loading";
import { makeStyles } from "@material-ui/core/styles";
import ProviderProfileEdition from "./ProviderProfileEdition";

export default function ProviderUserSettings() {
  const useStyles = makeStyles((theme) => ({
    container: {
      display: "flex",
      flexWrap: "wrap",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
  }));
  const classes = useStyles();

  const [signatureURL, setSignatureURL] = useState(null);
  const localState = userLocalState();
  const [loading, setLoading] = useState(false);

  const sigCanvas = useRef({});

  const clear = () => {
    sigCanvas.current.clear();
  };

  const handleSignature = () => {
    setSignatureURL(
      sigCanvas.current.getTrimmedCanvas().toDataURL("image/png")
    );
    console.log(signatureURL);
  };

  const save = () => {
    if (true) {
      const url = `${process.env.REACT_APP_API_URL_BASE}/provider/update`;
      setLoading(true);
      Axios.put(
        url,
        {
          id: localState[0].user.provider.id,
          signature: signatureURL,
        },
        {
          headers: { Authorization: "Bearer " + localState[0].jwt }, //the jwt is a variable which holds the token
        }
      )
        .then((res) => {
          setLoading(false);
          if (res.status == 200) {
            swal(
              "Success!",
              "Signature saved!, Now your prescriptions will be signed with this signature",
              "success"
            );
          }
        })
        .catch((error) => {
          console.log("Error Signature", error);
          setLoading(false);
          swal(
            "Error!",
            "Something went wrong saving signature, please try again later or contact Support",
            "alert"
          );
        });
    }
  };

  return (
    <>
      <DashboardMUI
        sectionTitle="User Settings"
        description="Set all your personal information and signature"
        icon={providerIcon}
      >
        <ProviderProfileEdition />

        <div className="row">
          <div className="col-12">
            <div className="m-3 p-3 shadow rounded-lg-custom bg-white">
              <h4 className="title-dashboard-card pt-3 mb-0">
                Add Your Signature
              </h4>
              <p className="text-center text-secondary">
                Please sign inside the box
              </p>
              <div className="row d-flex justify-content-center">
                <SignatureCanvas
                  onEnd={handleSignature}
                  ref={sigCanvas}
                  backgroundColor="white"
                  canvasProps={{
                    width: 500,
                    height: 400,
                    className: "rounded border border-info",
                  }}
                />
              </div>
              <div className="d-flex justify-content-center">
                {loading && (
                  <LoadingSpin type="spinningBubbles" color="#1d3557" />
                )}
              </div>
              <div className="row d-flex justify-content-center p-3">
                <Button
                  className="m-1"
                  variant="outlined"
                  color="primary"
                  startIcon={<ClearIcon />}
                  onClick={clear}
                >
                  Clear
                </Button>
                <Button
                  className="m-1"
                  variant="contained"
                  color="secondary"
                  startIcon={<CheckCircleOutlineIcon />}
                  onClick={save}
                >
                  Save
                </Button>
              </div>

              <div>
                {signatureURL ? (
                  <img
                    src={signatureURL}
                    alt="my signature"
                    style={{
                      display: "flex",
                      margin: "0 auto",
                      border: "1px solid black",
                      width: "150px",
                    }}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <div className="row"></div>
      </DashboardMUI>
    </>
  );
}
